// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"4fe51f4e","787":"010ebd60"}[chunkId] + ".chunk.js";
};